import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-734b1894"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "to this user:", -1))

import { computed, ref } from 'vue'
import { useDataGroupStore } from '@/gp/DataGroupStore'
import Modal from '@/util/Modal.vue'
import ProfileCard from '../ProfileCard.vue'
import ResearchGroupItem from '../researchgroups/ResearchGroupItem.vue'
import UserSelector from '../users/UserSelector.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'DataGroupTransferModal',
  props: {
    dataGroupId: {}
  },
  setup(__props: any) {

const props = __props;



const toUserIdRef = ref<string>()
const modalRef = ref<InstanceType<typeof Modal>>()
const userSelectorRef = ref<InstanceType<typeof UserSelector>>()

const dataGroupStore = useDataGroupStore()

const dataGroupRef = computed(() => dataGroupStore.getLoadedGroup(props.dataGroupId))
const groupTypeTextRef = computed(() => dataGroupRef.value?.isProfile ? 'profile' : 'tree')
const canTransferRef = computed(() => !!toUserIdRef.value)

function onShown() {
  toUserIdRef.value = undefined
  userSelectorRef.value?.clear()
  userSelectorRef.value?.focus()
}

async function transferAsync() {
  try {
    if (props.dataGroupId && toUserIdRef.value) {
      await dataGroupStore.transferAsync(props.dataGroupId, toUserIdRef.value)
      modalRef.value?.close()
    }
  }
  finally {
    modalRef.value?.reset()
  }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Modal, {
    ref_key: "modalRef",
    ref: modalRef,
    class: "transfer-modal",
    "ok-style": "warning",
    "ok-disabled": !canTransferRef.value,
    onShown: onShown,
    onOk: transferAsync
  }, {
    title: _withCtx(() => [
      _createTextVNode("Change owner")
    ]),
    okText: _withCtx(() => [
      _createTextVNode("Transfer now")
    ]),
    default: _withCtx(() => [
      _createElementVNode("label", null, "Transfer ownership of this " + _toDisplayString(groupTypeTextRef.value) + ":", 1),
      (dataGroupRef.value?.isProfile)
        ? (_openBlock(), _createBlock(ProfileCard, {
            key: 0,
            "show-profile-type": "",
            static: "",
            "person-id": dataGroupRef.value.startItemId
          }, null, 8, ["person-id"]))
        : (_openBlock(), _createBlock(ResearchGroupItem, {
            key: 1,
            "data-group-id": _ctx.dataGroupId
          }, null, 8, ["data-group-id"])),
      _hoisted_1,
      _createVNode(UserSelector, {
        ref_key: "userSelectorRef",
        ref: userSelectorRef,
        modelValue: toUserIdRef.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((toUserIdRef).value = $event))
      }, null, 8, ["modelValue"])
    ]),
    _: 1
  }, 8, ["ok-disabled"]))
}
}

})